export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'baisi-culture',
    name: '白丝文化',
    description: '深入探索白丝的历史渊源、文化内涵与社会意义，了解白丝在不同时代与地域的文化表达。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'trend-outfit',
    name: '潮流穿搭',
    description: '最新最全的白丝搭配灵感，从JK制服到日常通勤，让你的白丝穿搭更加出彩。',
    icon: 'ri-t-shirt-line',
  },
  {
    slug: 'buying-guide',
    name: '选购指南',
    description: '材质对比、品牌推荐、尺码选择，一份全面的白丝选购攻略助你找到最适合的那一双。',
    icon: 'ri-shopping-bag-3-line',
  },
  {
    slug: 'baisi-aesthetic',
    name: '白丝美学',
    description: '从摄影艺术到视觉设计，探索白丝在美学领域的无限可能与独特魅力。',
    icon: 'ri-palette-line',
  },
];